const CDN = "https://creato-sc.b-cdn.net/images/cottages/custom/large";

export const IMAGES = {
  hero: `${CDN}/192624452.jpg`,
  house: `${CDN}/192624369.jpg`,
  land: `${CDN}/192624360.jpg`,
  wellness: `${CDN}/192820144.jpg`,
  wedding: `${CDN}/192757825.jpg`,
  retreat: `${CDN}/192624383.jpg`,
  gallery: [
    { src: `${CDN}/192624452.jpg`, caption: "The Manor", span: "col-span-12 md:col-span-7 row-span-2" },
    { src: `${CDN}/192624378.jpg`, caption: "The Sitting Room", span: "col-span-6 md:col-span-5" },
    { src: `${CDN}/192624384.jpg`, caption: "The Kitchen", span: "col-span-6 md:col-span-5" },
    { src: `${CDN}/192624395.jpg`, caption: "The Gardens", span: "col-span-6 md:col-span-4" },
    { src: `${CDN}/192820144.jpg`, caption: "Wellness Suite", span: "col-span-6 md:col-span-4" },
    { src: `${CDN}/192624390.jpg`, caption: "Gathering Spaces", span: "col-span-6 md:col-span-4" },
    { src: `${CDN}/192624389.jpg`, caption: "Details", span: "col-span-6 md:col-span-5" },
    { src: `${CDN}/192757825.jpg`, caption: "The Grounds", span: "col-span-6 md:col-span-7" },
  ],
};

export const CHAPTERS = [
  {
    id: "house",
    number: "01",
    title: "The House",
    heading: "A manor, lovingly reimagined",
    body: "Bron Menai is a characterful country manor house, lovingly restored by FERAL for meaningful gatherings. Eight elegant ensuite bedrooms sleep fifteen in the main house, rising to twenty-three with the neighbouring cottages — generous living spaces, layered textures and quiet luxury throughout.",
    image: IMAGES.house,
    facts: ["8 ensuite bedrooms", "Sleeps 15, up to 23", "Restored by FERAL"],
  },
  {
    id: "land",
    number: "02",
    title: "The Land",
    heading: "Eight acres between forest and sea",
    body: "Set within eight private acres of grounds on the edge of Newborough, the manor sits minutes from Newborough Beach, the pine forest and the tidal island of Llanddwyn. Marram grass, wide skies and the mountains of Eryri on the horizon.",
    image: IMAGES.land,
    facts: ["8 private acres", "4 miles to Newborough Beach", "Views toward Eryri"],
  },
  {
    id: "wellness",
    number: "03",
    title: "The Wellness Suite",
    heading: "A sanctuary below the house",
    body: "Beneath the manor, a basement wellness suite built for deep restoration — a cedar sauna, cold plunge, hot tub and a quiet meditation space. Days here move between heat, cold, breath and stillness.",
    image: IMAGES.wellness,
    facts: ["Cedar sauna", "Cold plunge", "Hot tub & meditation space"],
  },
  {
    id: "weddings",
    number: "04",
    title: "Weddings",
    heading: "Your day, your house, your shoreline",
    body: "Take over Bron Menai entirely for an intimate coastal wedding. Exchange vows between forest and sea, dine beneath the manor's old beams and dance late into a Welsh summer night — with bedrooms for your favourite people, steps away.",
    image: IMAGES.wedding,
    facts: ["Exclusive multi-day hire", "House & grounds takeover", "Sleeps your wedding party"],
  },
  {
    id: "retreats",
    number: "05",
    title: "Retreats",
    heading: "Built for coming back to yourself",
    body: "Wellness, yoga, fitness, nature and watersports retreats find a natural home here. Purposeful spaces for movement and breathwork, a wellness suite for recovery, and eight acres of wild calm to hold it all.",
    image: IMAGES.retreat,
    facts: ["Yoga & movement spaces", "Nature & watersports", "Sensory healing in the wild"],
  },
];

export const MARQUEE_ITEMS = [
  "Newborough Beach",
  "Basement Wellness",
  "Llanddwyn Island",
  "8 Ensuite Bedrooms",
  "8 Private Acres",
  "Bespoke Weddings",
  "Mindful Retreats",
];

export const CHAPTER_IMAGES = [IMAGES.house, IMAGES.land, IMAGES.wellness, IMAGES.wedding, IMAGES.retreat];

export const NAV_LINKS = [
  { id: "house", label: "The House" },
  { id: "land", label: "The Land" },
  { id: "wellness", label: "Wellness" },
  { id: "weddings", label: "Weddings" },
  { id: "retreats", label: "Retreats" },
  { id: "gallery", label: "Gallery" },
];
